/// <amd-module name="Wit/Common/QueryUtils/QueriesHubConstants" />
export const FavoritesTab = "favorites";
export const FolderView = "folder";
export const AllQueriesTab = "all";

export const Area = "QueriesHub2";

export const FavoriteTabViewed = "FavoriteTabViewed";
export const AllTabViewed = "AllTabViewed";
export const ChartsTabViewed = "ChartsTabViewed";
export const EditorTabViewed = "EditorTabViewed";
export const ResultsViewed = "ResultsViewed";
export const WorkItemEditViewed = "WorkItemEditViewed";
export const QueriesHubViewed = "QueriesHubViewed";

export const TelemetryArea = "New-Queries-Hub";
export const TelemetryFeature = "query-service";

export const MoreButtonId = "more-button-";

export const FavoriteArtifactScopeType = "Project";
export const FavoriteOwnerScope = "Team";
export const TeamFavoriteLoadingGroupKey = "TEAM_FAVORITES_LOADING";
export const MyFavoritesGroupKey = "MY_FAVORITES_GROUP";

export const MaximumQueriesToShow = 50;
export const KeywordFilterKey = "keyword";

export const QueriesPath = "Queries";
export const SplitterDirectionKey = `${QueriesPath}/SplitterDirection`;
export const WorkItemFormSplitterSize = `${QueriesPath}/WorkItemFormSplitterRatio`;
export const EditorTableSplitterSize = `${QueriesPath}/EditorTableSplitterRatio`;
export const SettingsKey = "setting";

export const QueryFoldersDelimiter = "/";
